var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColdStressLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    viewBox: "0 0 6 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 34",
    d: "M3.5 5.1875L5.88675 0.1875L0.113249 0.1875L2.5 5.1875L3.5 5.1875ZM2.5 4.6875L2.50001 137.188L3.50001 137.187L3.5 4.6875L2.5 4.6875Z",
    fill: "#0092E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdStressLine);
export default __webpack_public_path__ + "static/media/Cold_Stress_Line.749cfe299d15b212b72ee33cea1140d8.svg";
export { ForwardRef as ReactComponent };